
(() => {
  // TONI SAILER – WILL Geschenkaktion
  // Ein MEN SUSPENDER pro Warenkorb mit mindestens einer WILL.

  const WILL_PRODUCT_IDS = new Set([
    10562217345290, // WILL Apero
    10562226028810, // WILL Mykonos
    10562227405066, // WILL Midnight
    10562230124810, // WILL Signal Red
    10562231402762, // WILL Black
    10562233041162, // WILL Bright White
    10562239299850, // WILL Short Length
  ]);

  const GIFT_VARIANT_ID = 42610611257577;
  const GIFT_PROPERTY = "_will_free_suspender";
  const GIFT_VALUE = "yes";

  const root = window.Shopify?.routes?.root || "/";

  let busy = false;
  let rerun = false;
  let timer;

  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? "POST" : "GET",
      headers: body
        ? { "Content-Type": "application/json" }
        : {},
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      throw new Error("Shopify cart request failed");
    }

    return response.json();
  }

  function isGift(item) {
    return (
      Number(item.variant_id) === GIFT_VARIANT_ID &&
      item.properties?.[GIFT_PROPERTY] === GIFT_VALUE
    );
  }

  async function synchronize() {
    if (busy) {
      rerun = true;
      return;
    }

    busy = true;
    let changed = false;

    try {
      const cart = await request("cart.js");

      const hasWill = cart.items.some((item) =>
        WILL_PRODUCT_IDS.has(Number(item.product_id))
      );

      const gifts = cart.items.filter(isGift);

      if (hasWill && gifts.length === 0) {
        await request("cart/add.js", {
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              [GIFT_PROPERTY]: GIFT_VALUE,
            },
          }],
        });

        changed = true;
      }

      if (!hasWill && gifts.length > 0) {
        for (const gift of gifts) {
          await request("cart/change.js", {
            id: gift.key,
            quantity: 0,
          });
        }
        changed = true;
      }

      if (hasWill && gifts.length > 0) {
        // Sicherstellen, dass nur ein Geschenk bleibt.
        const [first, ...duplicates] = gifts;

        if (first.quantity !== 1) {
          await request("cart/change.js", {
            id: first.key,
            quantity: 1,
          });
          changed = true;
        }

        for (const duplicate of duplicates) {
          await request("cart/change.js", {
            id: duplicate.key,
            quantity: 0,
          });
          changed = true;
        }
      }

      if (changed) {
        if (
          document.body.classList.contains("template-cart")
        ) {
          window.location.reload();
          return;
        }

        document.dispatchEvent(
          new CustomEvent("cart-drawer:refresh")
        );
      }
    } catch (error) {
      console.error("WILL gift synchronization:", error);
    } finally {
      busy = false;

      if (rerun) {
        rerun = false;
        scheduleSync();
      }
    }
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(synchronize, 350);
  }

  function initialize() {
    // Prüfung beim Laden der Seite.
    scheduleSync();

    // Auf Warenkorbänderungen des Wonder-Themes reagieren.
    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
    }

    // Zusätzliche Prüfung beim Öffnen des Drawers.
    document.addEventListener(
      PUB_SUB_EVENTS?.cartDrawerOpen ||
        "cart-drawer:open",
      scheduleSync
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }
})();
